"use client";

import React from "react";
import { CircleCheck, MonitorPlay } from "lucide-react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
const tabs = [{
  id: "corporate",
  label: "Corporate"
}, {
  id: "education",
  label: "Education"
}, {
  id: "specialized",
  label: "Specialized"
}];
const spaces = [{
  id: "c1",
  tabId: "corporate",
  title: "Conference & Boardrooms",
  image: "https://suitable-martin.10web.cloud/wp-content/uploads/2026/03/20240119_153354561_iOS-scaled.jpg?v=dm5jzsx5u4e"
}, {
  id: "c2",
  tabId: "corporate",
  title: "Huddle Areas & Open Offices",
  image: "https://suitable-martin.10web.cloud/wp-content/uploads/2026/03/20240119_152938141_iOS-scaled.jpg?v=g0p0p227em"
}, {
  id: "c3",
  tabId: "corporate",
  title: "Lobbies & Common Spaces",
  image: "https://www.wt-solutions.com/wp-content/uploads/2026/03/NRB1.jpg?v=itdhf0ymfi"
}, {
  id: "e1",
  tabId: "education",
  title: "Auditoriums & Classrooms",
  image: "https://suitable-martin.10web.cloud/wp-content/uploads/2026/03/WASH-U-Epnic.png?v=xckrsu08u4d"
}, {
  id: "e2",
  tabId: "education",
  title: "Training & Multifunctional",
  image: "https://suitable-martin.10web.cloud/wp-content/uploads/2026/03/20240119_154203252_iOS-scaled.jpg?v=s0w2tj72l3p"
}, {
  id: "s1",
  tabId: "specialized",
  title: "Command Centers",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576635/img/specialized_command.png"
}, {
  id: "s2",
  tabId: "specialized",
  title: "Healthcare Environments",
  image: "https://www.wt-solutions.com/wp-content/uploads/2026/04/Med-Hall.jpg?v=5r8ayzw7me"
}, {
  id: "s3",
  tabId: "specialized",
  title: "Hospitality & Casinos",
  image: "https://suitable-martin.10web.cloud/wp-content/uploads/2026/03/02_1200x800.jpg?v=b6x14njqh6o"
}, {
  id: "s4",
  tabId: "specialized",
  title: "Government & Courthouses",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576635/img/specialized_government.png"
}];
const capabilities = [{
  spaceId: "c1",
  text: "Presentation & Video Conferencing"
}, {
  spaceId: "c1",
  text: "Professional Audio"
}, {
  spaceId: "c1",
  text: "Room Scheduling"
}, {
  spaceId: "c2",
  text: "Sound Masking"
}, {
  spaceId: "c2",
  text: "Digital Signage"
}, {
  spaceId: "c2",
  text: "Turnkey System Integration"
}, {
  spaceId: "c3",
  text: "Direct View LED Video Walls"
}, {
  spaceId: "c3",
  text: "Public Address Systems"
}, {
  spaceId: "e1",
  text: "Professional Audio"
}, {
  spaceId: "e1",
  text: "Presentation Systems"
}, {
  spaceId: "e1",
  text: "Custom AV Design"
}, {
  spaceId: "e2",
  text: "Video Conferencing"
}, {
  spaceId: "e2",
  text: "Turnkey Integration"
}, {
  spaceId: "s1",
  text: "Direct View LED Video Walls"
}, {
  spaceId: "s1",
  text: "Low Voltage & Data Services"
}, {
  spaceId: "s1",
  text: "Custom AV Design"
}, {
  spaceId: "s2",
  text: "Public Address & Paging"
}, {
  spaceId: "s2",
  text: "Sound Masking"
}, {
  spaceId: "s3",
  text: "Professional Audio"
}, {
  spaceId: "s3",
  text: "Turnkey System Integration"
}, {
  spaceId: "s4",
  text: "Secure Video Conferencing"
}, {
  spaceId: "s4",
  text: "Custom AV Design"
}];
export default function EnvironmentExpertise() {
  return <section id="environment-expertise" className="dark bg-background text-foreground py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-primary/5 blur-[120px] rounded-full pointer-events-none" />

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-4 flex items-center justify-center gap-3">
            <MonitorPlay className="w-8 h-8 text-primary" />
            Environment Expertise
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg">We plan, build, and implement AV systems that help your organization communicate, collaborate, and present information effectively, regardless of the type of space.</p>
        </div>

        <Tabs defaultValue="corporate" className="w-full">
          <div className="flex justify-center mb-12">
            <TabsList className="bg-card/50 backdrop-blur-md border border-border/50 p-1.5 rounded-xl h-auto">
              {tabs.map((tab, i) => <TabsTrigger key={tab.id} value={tab.id} data-index={i} className="rounded-lg px-6 py-3 text-sm md:text-base font-medium transition-all data-[state=active]:bg-primary data-[state=active]:text-primary-foreground data-[state=active]:shadow-md">
                  {tab.label}
                </TabsTrigger>)}
            </TabsList>
          </div>

          {tabs.map((tab, i) => <TabsContent key={tab.id} value={tab.id} data-index={i} className="mt-0 outline-none focus-visible:ring-0 animate-in fade-in-50 duration-500">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
                {spaces.filter(s => s.tabId === tab.id).map((space, j) => <Card key={space.id} data-index={j} className="bg-card/40 backdrop-blur-sm border-border/40 hover:border-primary/40 transition-all duration-300 overflow-hidden group flex flex-col">
                    <div className="h-48 overflow-hidden relative shrink-0">
                      <img src={space.image} alt={space.title} className="w-full h-full object-cover" />
                    </div>
                    <CardHeader className="relative z-20 -mt-10 pb-2 shrink-0">
                      <CardTitle className="text-xl font-semibold text-foreground tracking-tight !bg-[hsl(210,11%,15%)] !opacity-[1]">
                        {space.title}
                      </CardTitle>
                    </CardHeader>
                    <CardContent className="pt-4 flex-1">
                      <ul className="space-y-3">
                        {capabilities.filter(c => c.spaceId === space.id).map((cap, k) => <li key={k} data-index={k} className="flex items-start text-sm text-muted-foreground">
                            <CircleCheck className="w-4 h-4 text-primary mr-2.5 mt-0.5 shrink-0" />
                            <span className="leading-tight">{cap.text}</span>
                          </li>)}
                      </ul>
                    </CardContent>
                  </Card>)}
              </div>
            </TabsContent>)}
        </Tabs>
      </div>
    </section>;
}